import { NextResponse } from "next/server"

import { createSupabaseAdminClient } from "@/lib/supabase/admin"

type ContactPayload = {
  name: string
  email: string
  subject: string
  message: string
}

function isValidEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export async function POST(request: Request) {
  try {
    const body = (await request.json()) as Partial<ContactPayload>

    const payload: ContactPayload = {
      name: body.name?.trim() ?? "",
      email: body.email?.trim() ?? "",
      subject: body.subject?.trim() ?? "",
      message: body.message?.trim() ?? "",
    }

    const errors: Partial<Record<keyof ContactPayload, string>> = {}

    if (payload.name.length < 2) {
      errors.name = "Ім’я має містити щонайменше 2 символи."
    }

    if (!isValidEmail(payload.email)) {
      errors.email = "Вкажіть коректну email-адресу."
    }

    if (payload.subject.length < 3) {
      errors.subject = "Тема має містити щонайменше 3 символи."
    }

    if (payload.message.length < 10) {
      errors.message = "Повідомлення має містити щонайменше 10 символів."
    }

    if (Object.keys(errors).length > 0) {
      return NextResponse.json(
        { ok: false, message: "Помилка валідації.", errors },
        { status: 400 },
      )
    }

    const supabase = createSupabaseAdminClient()

    const { data, error } = await supabase
      .from("contact_messages")
      .insert({
        name: payload.name,
        email: payload.email,
        subject: payload.subject,
        message: payload.message,
      })
      .select("id, name, email, subject, message, created_at")
      .single()

    if (error) {
      return NextResponse.json(
        { ok: false, message: error.message },
        { status: 500 },
      )
    }

    return NextResponse.json({
      ok: true,
      message: "Повідомлення збережено в Supabase.",
      data,
    })
  } catch {
    return NextResponse.json(
      { ok: false, message: "Не вдалося обробити запит." },
      { status: 500 },
    )
  }
}
